import React from 'react';
import { Button, Input, Select, Upload } from 'antd';
import { DeleteOutlined, PictureOutlined } from '@ant-design/icons';
import { includes, pathOr } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import { Components } from '@fasstech/flexiget';

const FIT_MODES = ['cover', 'contain'];

const BACKGROUND_FIT_OPTIONS = [
  { value: 'cover', label: 'Cover — remplit la section' },
  { value: 'contain', label: 'Contain — image entière visible' }
];

const BACKGROUND_POSITION_OPTIONS = [
  { value: 'top left', label: 'En haut à gauche' },
  { value: 'top center', label: 'En haut au centre' },
  { value: 'top right', label: 'En haut à droite' },
  { value: 'center left', label: 'Centré à gauche' },
  { value: 'center center', label: 'Centré' },
  { value: 'center right', label: 'Centré à droite' },
  { value: 'bottom left', label: 'En bas à gauche' },
  { value: 'bottom center', label: 'En bas au centre' },
  { value: 'bottom right', label: 'En bas à droite' }
];

const BackgroundImageSection = ({
  section,
  setPendingBackgroundImage,
  clearBackgroundImage,
  updateBackgroundSize,
  updateBackgroundPosition,
  userCanEdit
}) => {
  const savedUrl = pathOr('', ['backgroundImage', 'url'], section);
  const pendingFile = pathOr(null, ['backgroundImage', 'pendingFile'], section);
  const backgroundSize = pathOr('contain', ['backgroundImage', 'size'], section);
  const backgroundPosition = pathOr('center center', ['backgroundImage', 'position'], section);

  const hasImage = isNotNilOrEmpty(savedUrl) || isNotNilOrEmpty(pendingFile);

  const isFitMode = includes(backgroundSize, FIT_MODES);
  const fitModeValue = isFitMode ? backgroundSize : undefined;
  const freeSizeValue = isFitMode ? '' : backgroundSize;

  const handleBeforeUpload = (file) => {
    setPendingBackgroundImage(file);
    return false;
  };

  return (
    <div className="w-full">
      <div className="flex items-center mb-2">
        <Components.Tooltip title="Image de fond de la section">
          <PictureOutlined />
        </Components.Tooltip>
        <div className="flex items-center space-x-2 flex-1 ml-2">
          {hasImage ? (
            <Components.Tooltip title="Supprimer l'image de fond">
              <Button
                size="small"
                icon={<DeleteOutlined />}
                onClick={clearBackgroundImage}
                danger
                disabled={!userCanEdit}
              >
                Supprimer l'image de fond
              </Button>
            </Components.Tooltip>
          ) : (
            <Upload
              name="file"
              accept=".jpg,.jpeg,.png"
              showUploadList={false}
              beforeUpload={handleBeforeUpload}
              disabled={!userCanEdit}
            >
              <Button
                className="small-white-button"
                size="small"
                disabled={!userCanEdit}
              >
                Ajouter une image de fond
              </Button>
            </Upload>
          )}
        </div>
      </div>

      {hasImage && (
        <div className="flex flex-col space-y-2 pl-6">
          <div className="flex items-center space-x-2">
            <span className="text-xs w-12 text-gray-600 shrink-0">Mode</span>
            <Select
              size="small"
              className="w-full"
              placeholder="cover / contain"
              value={fitModeValue}
              options={BACKGROUND_FIT_OPTIONS}
              onChange={(v) => updateBackgroundSize(v)}
              disabled={!userCanEdit}
              allowClear
              onClear={() => updateBackgroundSize('')}
            />
          </div>

          <div className="flex items-center space-x-2">
            <span className="text-xs w-12 text-gray-600 shrink-0">Taille</span>
            <Input
              size="small"
              className="flex-1"
              placeholder="ex: 100%, 200px auto"
              value={freeSizeValue}
              onChange={(e) => updateBackgroundSize(e.target.value)}
              disabled={!userCanEdit}
            />
          </div>

          <div className="flex items-center space-x-2">
            <span className="text-xs w-12 text-gray-600 shrink-0">Position</span>
            <Select
              size="small"
              className="flex-1"
              placeholder="center center"
              value={isNotNilOrEmpty(backgroundPosition) ? backgroundPosition : undefined}
              options={BACKGROUND_POSITION_OPTIONS}
              onChange={updateBackgroundPosition}
              disabled={!userCanEdit}
              allowClear
              onClear={() => updateBackgroundPosition('')}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BackgroundImageSection;
